import Alpine from "alpinejs";
import { dispatch } from "../utils/events.ts";

const contentLocation: Alpine.DirectiveCallback = (el, _, { cleanup }) => {
  function collectBlocks(nodeList: NodeList): HTMLElement[] {
    const results = [];
    for (let added of nodeList) {
      const tlDoc = added as HTMLElement;
      if (tlDoc === null || tlDoc.id !== "termlynx-parser-doc") {
        continue;
      }

      for (let block of tlDoc.querySelectorAll<HTMLDivElement>(
        "div[data-scope-name]"
      )) {
        results.push(block);
      }
    }

    return results;
  }

  const intersectionObserver = new IntersectionObserver(
    (entries) => {
      // Filter for entries that are currently crossing the defined top boundary line
      const intersectingEntries = entries.filter(
        (entry) => entry.isIntersecting
      );

      if (intersectingEntries.length > 0) {
        intersectingEntries.sort((a, b) => {
          if (!a?.boundingClientRect || !b?.boundingClientRect) return 0;
          return a.boundingClientRect.top - b.boundingClientRect.top;
        });

        const topEntry = intersectingEntries[0];
        const location = topEntry.target.getAttribute("data-scope-name");

        if (location) {
          dispatch("content-scroll-location", { el, location });
        }
      }
    },
    {
      root: el,
      threshold: 0,
      // We add a little padding of 8px, so paragraph that shows less than 8px of
      // of their bottom won't trigger intersection event
      rootMargin: "-8px 0px -100% 0px",
    }
  );

  const crudObserver = new MutationObserver((entries) => {
    for (let entry of entries) {
      for (let block of collectBlocks(entry.removedNodes)) {
        intersectionObserver.unobserve(block);
      }
      for (let block of collectBlocks(entry.addedNodes)) {
        intersectionObserver.observe(block);
      }
    }
  });

  crudObserver.observe(el, {
    childList: true,
  });

  for (let entry of el.querySelectorAll("div[data-scope-name]")) {
    intersectionObserver.observe(entry);
  }

  cleanup(() => {
    intersectionObserver.disconnect();
    crudObserver.disconnect();
  });
};
export default contentLocation;
